<template>
  <div class="content">
    <div class="md-layout md-alignment-center-center">
      <div
        class="md-layout-item md-xlarge-size-75 md-large-size-100 md-small-size-100 md-xsmall-size-100"
      >
        <md-card>
          <md-card-header data-background-color="secondary">
            <h4 class="title">Market Tours</h4>
            <p class="category">Take a tour of Sydney Markets</p>
          </md-card-header>
          <div class="md-card-content">
            <MarketTourForm />
          </div>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import MarketTourForm from "@/views/Forms/MarketTourForm";
export default {
  components: { MarketTourForm }
};
</script>
